import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Component, Input, Output, OnInit, OnChanges, ViewContainerRef, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { Document } from 'app/shared/models/document.model';
import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { User } from 'app/shared/models/user.model';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';
import { EntityDocumentsService } from 'app/entities/documents/entity-documents.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ConfirmationDialogComponent } from 'app/shared/components/confirmationdialog/confirmation-dialog.component';
import { AddLabelComponent } from 'app/entities/documents/addlabel/add-label.component';
import { AddDocumentComponent } from 'app/shared/components/adddocument/add-document.component';


@Component({
  selector: 'document-details',
  templateUrl: './document-details.component.html',
})

export class DocumentDetailsComponent implements OnInit, OnChanges {
  @Input()
  document: Document;
  @Input()
  entityId: number;

  entityDetails: EntityIdDetails;
  dialogRef: MdDialogRef<any>;
  documentTypes: ApplicationValue[];
  labelIds = [];
  users: User[];
  loginUser = '';
  documentOwner: string;

  constructor(
    public dialog: MdDialog,
    private snackBarService: SnackBarService,
    private cookieService: CookieService,
    private warmUpService: WarmUpService,
    private viewContainerRef: ViewContainerRef,
    private entityDocumentsService: EntityDocumentsService
  ) { }

  ngOnInit() {
    this.users = this.warmUpService.getUsersList();
    this.labelIds = this.document.labels && Object.keys(this.document.labels) || [];
    this.loginUser = this.cookieService.get(ConstantsService.COOKIE_LOGIN_USER_NAME);
    const owner = this.users.find(user => user.loginId === this.document.docOwner);
    this.documentOwner = owner && owner.name;
  }

  ngOnChanges() {
    this.loadCategoryTypes(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.DOCUMENT_TYPE));
  }

  loadCategoryTypes(documentTypeValues: any) {
    if (documentTypeValues instanceof Observable) {
      documentTypeValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.documentTypes = response.values;
        }
      );
    } else {
      this.documentTypes = documentTypeValues;
    }
  }

  openDeleteDocumentDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
    this.dialogRef.componentInstance.message = 'Are you sure you want to delete this document?';
    this.dialogRef.componentInstance.title = 'Delete Document';
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteDocument(this.document.id);
      }
    });
  }

  deleteDocument(documentId: number): void {
    this.entityDocumentsService.deleteDocument(documentId)
      .subscribe(response => {
        this.entityDocumentsService.updatedDoucment.emit({ action: 'delete', document: this.document });
        this.callSnackBarService(response, MessageService.DELETE_DOCUMENT_SUCCESS);
      }, err => {
        this.callSnackBarService(err, '');
      }
      );
  }

  deleteDocumentLabel(labelId: number) {
    this.entityDocumentsService.deleteDocumentLabel(this.document.id, labelId)
      .subscribe(response => {
        delete this.document.labels[labelId];
        this.labelIds.splice(this.labelIds.indexOf(labelId), 1);
        this.entityDocumentsService.updatedDoucment.emit({ action: 'label', document: this.document });
        this.callSnackBarService(response, MessageService.DELETE_LABEL_SUCCESS);
      }, err => {
        this.callSnackBarService(err, '');
      }
      );
  }

  toDateString(miliseconds: number) {
    return new Date(miliseconds).toDateString();
  }

  openAddLabelDialog(selectedDocument: Document) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddLabelComponent, config);
    this.dialogRef.componentInstance.selectedDocument = this.document;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.entityDocumentsService.updatedDoucment.emit({ action: 'label', document: this.document });
      }
    });
  }

  openEditDocumentDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddDocumentComponent, config);
    this.dialogRef.componentInstance.action = 'Edit';
    this.dialogRef.componentInstance.selectedDocument = this.document;
    this.dialogRef.componentInstance.entityId = this.entityId;
    this.dialogRef.afterClosed().subscribe(result => {

    });
  }

  downloadDocument(id: number) {
    window.open(ConstantsService.APP_BE_URL +'/'+ ConstantsService.DOWNLOAD_DOCUMENT + '?documentId=' + id);
  }

  callSnackBarService(response: any, successMsg) {
    this.snackBarService
      .showStatus(response,
      successMsg,
      MessageService.DOCUMENT_FAILURE);
  }

  getDocumentTypeName(docType: number) {
    return docType && this.documentTypes.find(documentType => {
      return documentType.id === docType;
    }).name || '';
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/documents/documentdetails/document-details.component.ts